import cn from 'classnames'
import { motion } from 'framer-motion'
import React from 'react'

import * as s from './Dragline.module.scss'

interface IDraglineProps {
  direction: 'vertical' | 'horizontal'
}

const Dragline: React.FC<IDraglineProps> = ({ direction }) => {
  return (
    <motion.div
      className={cn(s.root, s[direction])}
      layout='position'
      layoutId='dragline'
      transition={{ duration: 0.1, ease: 'linear' }}
    />
  )
}

export default Dragline
